import styled from "styled-components";
import Colors from "../../global/color.js";

const StyledContainer = styled.div`
  width: ${({ clientContext }) =>
    clientContext.isMobile
      ? "228px"
      : clientContext.isTablet
      ? "225px"
      : "218px"};
  padding: ${({ clientContext }) =>
    clientContext.isMobile
      ? "0px 16px 0px 16px"
      : clientContext.isTablet
      ? "0px 16px 0px 16px"
      : "5px 16px 5px 16px"};
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: center;
`;

const StyledCategory = styled.a`
  text-decoration: none;
  display: block;
`;

const StyledTitle = styled.div``;

const StyledLink = styled.a`
  font-family: FuturaPT-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: ${({ clientContext }) =>
    clientContext.isMobile || clientContext.isTablet ? "16px" : "20px"};
  line-height: ${({ clientContext }) =>
    clientContext.isMobile || clientContext.isTablet ? "22px" : "26px"};
  letter-spacing: 0.25px;
  color: #000000;
  text-decoration: none;
  margin-top: 10px;
  &:hover {
    text-decoration: underline ${Colors.gold};
  }
`;

const StyledDate = styled.div``;

const StyledCaption = styled.div``;

const StyledBody = styled.div``;

const StyledAuthorName = styled.div`
  font-family: FuturaPT-Book;
  font-style: normal;
  font-weight: 500;
  font-size: ${({ clientContext }) =>
    clientContext.isMobile || clientContext.isTablet ? "14px" : "16px"};
  line-height: 22px;
  margin-top: 10px;
`;

const StyledAuthorRole = styled.div`
  font-family: FuturaPT-Book;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: ${Colors.mediumGrey};
`;

export {
  StyledContainer,
  StyledLink,
  StyledDate,
  StyledCategory,
  StyledTitle,
  StyledCaption,
  StyledBody,
  StyledAuthorName,
  StyledAuthorRole,
};
